import React, { useState } from 'react';
import { StyledMenu } from './StylesMenu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ListItemIcon, ListItemText, Typography } from '@mui/material';
import { Work } from '@mui/icons-material';
import { formatDate } from '../../../lib/utils';
import AddUserProject from '../../MyProfile/user-projects/AddUserProject';
import { Guard } from '../../../features/Guard';

export default function ProjectDropDown({ projectList, fetchprojectList }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { projectId } = useParams();
  const open = Boolean(anchorEl);
  const [openAdd, setOpenAdd] = useState(false);
  const location = useLocation()
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
    handleClose();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickRoute = () => {
    setAnchorEl(null)
    if (location.pathname !== '/projects') {
      navigate("/projects")
    }
  }

  return (
    <>
      <Button
        id="project-dropdown"
        aria-controls={open ? 'project-dropdown-btn' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="text"
        disableElevation
        sx={{ color: 'var(--primary-color)', fontWeight: 'bold', ml: 5 }}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}>
        Projects
      </Button>
      <StyledMenu
        id="project-dropdown-btn"
        MenuListProps={{
          'aria-labelledby': 'project-dropdown',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <MenuItem onClick={handleClose} sx={{ pointerEvents: 'none' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Recent
          </Typography>
        </MenuItem>

        {projectList && projectList?.length > 0 ? (
          projectList?.map((project) => {
            return (
              <Tooltip
                key={project.id}
              title={project.name} 
              placement="right"
              arrow
              >
              <MenuItem
                key={project.id}
                sx={{
                  backgroundColor:
                    project.id === projectId ? 'lightgrey' : 'white',
                }}>
                <Link
                  to={`/project/${project.id}/dashboard`}
                  reloadDocument
                  style={{ display: 'flex' }}>
                  <ListItemIcon>
                    <Work />
                  </ListItemIcon>
                  <ListItemText
                    primary={`${project?.name?.length > 10 ? project.name.slice(0,10) + '...' : project.name} (${project.key})`}
                    secondary={`Created on ${formatDate(project.created_at)}`}
                    primaryTypographyProps={{
                      sx: { fontWeight: 'bold', color: 'navyblue' },
                    }}
                    secondaryTypographyProps={{
                      sx: { color: 'grey.500', fontSize: '0.75rem' },
                    }}
                  />
                </Link>
              </MenuItem>
              </Tooltip>
            );
          })
        ) : (
          <MenuItem sx={{ pointerEvents: 'none' }}>
            <ListItemText
              primary="No Projects Added Yet"
              sx={{ textAlign: 'center', color: 'navyblue' }}
            />
          </MenuItem>
        )}
        <Divider sx={{ borderColor: 'black', my: 0.5 }} />
        <MenuItem onClick={handleClickRoute}>
          <ListItemText sx={{ textAlign: 'center' }} primary="View All Projects" />
        </MenuItem>
        <Divider sx={{ borderColor: 'black', my: 0.5 }} />
        <Guard policy="ManageProjects">
          <MenuItem onClick={handleClickOpenAdd}>
            <ListItemText sx={{ textAlign: 'center' }} primary="Add New Project" />
          </MenuItem>
        </Guard>
      </StyledMenu>
      <AddUserProject
        open={openAdd}
        setOpen={setOpenAdd}
        fetchProjectData={fetchprojectList}
      />
    </>
  );
}
